import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-articles'

const path = 'articles/news'
const resolveRelations = 'ArticleTemplate.relatedJargon'
const shouldUndashifyAndCapitalise = true

const passedBreadCrumbs = [
  { text: 'Home', url: '/' },
  { text: 'News', url: '/news' },
]

export const getStaticProps = getStaticPropsGenerator({
  path,
  resolveRelations,
  passedBreadCrumbs,
  shouldUndashifyAndCapitalise,
})

export const getStaticPaths = getStaticPathsGenerator(path)

export { ArticlesFeature as default } from '@cinch-nx/landing-feature-articles'
